<div class="plan-container">
	<mat-card class="container-ayudas">
		<mat-card-title-group>
			<mat-card-title>Proyectos</mat-card-title>
			<div class="header-buttons right-align" *ngIf="canCreate">
				<mat-card-content>
					<button
						mat-raised-button
						[routerLink]="['/recursos/proyectos/form']"
						color="primary"
					>
						<mat-icon class="mr1">add</mat-icon>
						<span>Crear proyecto</span>
					</button>
				</mat-card-content>
			</div>
		</mat-card-title-group>
		<mat-card-content>
			<div class="clearfix filters">
				<form [formGroup]="filtersForm">
					<div class="col col-3 px2">
						<mat-form-field appearance="standard">
							<mat-label>Buscar</mat-label>
							<input
								matInput
								placeholder="Buscar elementos"
								#input
								formControlName="name"
							/>
						</mat-form-field>
					</div>
					<div class="col col-3 px2">
						<mat-form-field appearance="fill">
							<mat-label>Tipo de financiación</mat-label>
							<mat-select formControlName="tipo_financiacion">
								<mat-option>Todos los tipos</mat-option>
								<mat-option
									[value]="item.id"
									*ngFor="let item of list_tipo_financiacion"
									>{{ item.name }}</mat-option
								>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col col-3 px2">
						<mat-form-field appearance="fill">
							<mat-label>Tipo de proyecto</mat-label>
							<mat-select formControlName="tipo_proyecto">
								<mat-option>Todos los tipos</mat-option>
								<mat-option
									[value]="item.id"
									*ngFor="let item of list_tipos_proyecto"
									>{{ item.name }}</mat-option
								>
							</mat-select>
						</mat-form-field>
					</div>
				</form>
			</div>
			<table
				mat-table
				[dataSource]="dataSource"
				class="table-listado table-proyectos"
			>
				<!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

				<!-- Position Column -->
				<ng-container matColumnDef="nombre">
					<th mat-header-cell *matHeaderCellDef>Nombre.</th>
					<td mat-cell *matCellDef="let element">
						<span>{{ element.name }}</span>
						</td>
				</ng-container>

				<!-- Name Column -->
				<ng-container matColumnDef="tipo_proyecto">
					<th mat-header-cell *matHeaderCellDef>Tipo Financiación</th>
					<td mat-cell *matCellDef="let element">
						<span>{{ getTipoProyecto(element.type) }}</span>
					</td>
				</ng-container>

				<!-- Weight Column -->
				<ng-container matColumnDef="tipo_financiacion">
					<th mat-header-cell *matHeaderCellDef>Tipo Proyecto</th>
					<td mat-cell *matCellDef="let element">
						<span>{{ getTipoFinanciacion(element.funding_type) }}</span>
					</td>
				</ng-container>

				<!-- Symbol Column -->
				<ng-container matColumnDef="descripcion">
					<th mat-header-cell *matHeaderCellDef>Descripción</th>
					<td mat-cell *matCellDef="let element"><span>{{ element.description }}</span></td>
				</ng-container>

				<!-- Symbol Column -->
				<ng-container matColumnDef="actions" *ngIf="canCreate">
					<th mat-header-cell *matHeaderCellDef>Acciones</th>
					<td mat-cell *matCellDef="let element">
						<div>
							<button
								mat-icon-button
								color="primary"
								title="Modificar"
								[routerLink]="['/recursos/proyectos/form', element.id]"
							>
								<mat-icon>edit</mat-icon>
							</button>
							<button
								mat-icon-button
								class="text-danger"
								title="Eliminar"
								color="primary"
								(click)="confirm(element.id)"
								*ngIf="!element.hasDeliveries"
							>
								<mat-icon>delete</mat-icon>
							</button>
						</div>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
			<mat-paginator
				[pageSizeOptions]="[10, 25, 50]"
				pageSize="10"
				[length]="dataSource.data.length"
				(page)="scrollUp()"
			></mat-paginator>
		</mat-card-content>
	</mat-card>
</div>
